/**
 * Drop-in currency icon: the Chillet gold coin.
 *
 * Mirrors the lucide-icon API (`size`, `className`, `style`) so it can
 * be used anywhere the old `ChilletSkull` was used to represent the
 * site's currency (Chillet Coins).
 *
 * The skull icon (`ChilletSkull`) is still used for branding (header
 * logo, auth screens, loader spinner) — only currency surfaces moved
 * to this coin icon.
 */
export function ChilletCoinIcon({ size = 24, className = "", style = {}, ...rest }) {
  const px = typeof size === "number" ? `${size}px` : size;
  return (
    <span
      data-testid="chillet-coin-icon"
      className={`inline-flex items-center justify-center align-middle ${className}`}
      style={{
        width: px,
        height: px,
        lineHeight: 0,
        ...style,
      }}
      {...rest}
    >
      <img
        src="/icons/chillet_coin_heads.png"
        alt="Chillet coin"
        draggable={false}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "contain",
          userSelect: "none",
          pointerEvents: "none",
        }}
      />
    </span>
  );
}

export default ChilletCoinIcon;
